var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import MuiAvatar from '@mui/material/Avatar/Avatar';
import React, { createContext } from 'react';
export var sizeLargeClassName = 'pigment-avatar-large';
export var groupedClassName = 'pigment-avatar-grouped';
export var AvatarContext = createContext(false);
export var CounterAvatar = function (_a) {
    var className = _a.className, data = _a.data, _b = _a.text, text = _b === void 0 ? data : _b, props = __rest(_a, ["className", "data", "text"]);
    return (React.createElement(MuiAvatar, __assign({ className: "".concat(groupedClassName, " ") + className, sx: {
            backgroundColor: '#E3E3E3',
        } }, props), "+".concat(text)));
};
//# sourceMappingURL=utils.js.map